// extracted by mini-css-extract-plugin
module.exports = {"content":"_21620d3522--content--Wsv9u","subtitle":"_21620d3522--subtitle--K_6Rp"};